import React, { useEffect, useState } from "react";

import { Baseurl, Imageurl } from "../../config/BaseUrl";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom/dist";
import { useSelector } from "react-redux";
import "react-circular-progressbar/dist/styles.css";

const CommercialInsuranceReport = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { organisationLogo } = useSelector((store) => store.orgLogo);
  const { brandLogo } = useSelector((store) => store.brandLogo);
  const [caseinfo, setcaseinfo] = useState("");
  const [casePerfomanceinfo, setcasePerfomanceinfo] = useState("");

  const roundImageArray = [
    {
      label: "Broken",
      percentage: 5,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png",
    },
    {
      label: "Intact",
      percentage: 10,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png",
    },
  ];

  useEffect(() => {
    const caseId = params.caseId;
    const fetchData = async () => {
      try {
        const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
        const caseFetch = await axios.get(url);

        try {
          if (caseFetch.data.success) {
            const casedetails = caseFetch.data.case;

            setcaseinfo(casedetails);
            const vehicleType = casedetails.assetType;
            const carCasDetails = casedetails.commercial;

            let findEngineCon = "";
            let findEVMotorCon = "";
            let findTransmissionCon = "";
            let findSuspensionCon = "";
            let findBrakesCon = "";
            let findTyreCon = "";
            let findInteriorCon = "";
            let findBatteryCon = "";
            let findExteriorCon = "";
            let finalBreakCondition = "";
            let finalTyreCondition = "";

            let transmission = carCasDetails.transmission.transmissionCondition;
            if (
              vehicleType === "Commercial" ||
              vehicleType === "Commercial EV"
            ) {
              findEngineCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.engineCondition,
              );
              findEVMotorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.evMotorCondition,
              );
              findBatteryCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.electricals.batteryCondition,
              );
              findTransmissionCon = roundImageArray.find(
                (data) =>
                  data.label ===
                  carCasDetails.transmission.transmissionCondition,
              );

              findSuspensionCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.suspension.suspensionCondition,
              );

              findInteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.interiorCondition,
              );

              findExteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.exteriorCondition,
              );

              findTyreCon = roundImageArray.find(
                (data) =>
                  data.label ===
                  carCasDetails.tyresNConditions.truckTyreCondition,
              );
              const findRareBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.rearBrakeCondition,
              );

              const findFrontBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.frontBrakeCondition,
              );
              const totalBrackcon =
                Number(findFrontBrakesCon.percentage) +
                Number(findRareBrakesCon.percentage);
              findBrakesCon = Number(totalBrackcon) / 2;
              findBrakesCon = Math.round(findBrakesCon);

              if (findBrakesCon === 1 || findBrakesCon === 2) {
                finalBreakCondition = 2;
              } else if (findBrakesCon === 3 || findBrakesCon === 4) {
                finalBreakCondition = 4;
              } else if (findBrakesCon === 5 || findBrakesCon === 6) {
                finalBreakCondition = 5;
              } else if (findBrakesCon === 7 || findBrakesCon === 8) {
                finalBreakCondition = 7;
              } else if (findBrakesCon === 9 || findBrakesCon === 10) {
                finalBreakCondition = 10;
              }

              const findBreakCondition = roundImageArray.find(
                (data) => data.percentage === finalBreakCondition,
              );
              const findTyreCondition = roundImageArray.find(
                (data) => data.percentage === findTyreCon,
              );
              let overalRating = 0;

              if (casedetails.assetType === "Commercial EV") {
                const overalRating =
                  Number(findEVMotorCon.percentage) +
                  Number(findTransmissionCon.percentage) +
                  Number(findSuspensionCon.percentage) +
                  Number(findBatteryCon.percentage) +
                  Number(findExteriorCon.percentage) +
                  Number(findBreakCondition.percentage) +
                  Number(findTyreCon.percentage);

                const overalavg = Number(overalRating) / 7;

                setcasePerfomanceinfo({
                  findEVMotorCon: findEVMotorCon,
                  findTransmissionCon: findTransmissionCon,
                  findSuspensionCon: findSuspensionCon,
                  findBrakesCon: findBreakCondition,
                  findTyreCon: findTyreCon,
                  findBatteryCon: findBatteryCon,
                  findExteriorCon: findExteriorCon,
                  veralrating: overalavg.toFixed(2),
                });
              } else {
                overalRating =
                  Number(findEngineCon.percentage) +
                  Number(findTransmissionCon.percentage) +
                  Number(findSuspensionCon.percentage) +
                  Number(findInteriorCon.percentage) +
                  Number(findExteriorCon.percentage) +
                  Number(findBreakCondition.percentage) +
                  Number(findTyreCon.percentage);

                const overalavg = Number(overalRating) / 7;
                setcasePerfomanceinfo({
                  findEngineCon: findEngineCon,
                  findTransmissionCon: findTransmissionCon,
                  findSuspensionCon: findSuspensionCon,
                  findBrakesCon: findBreakCondition,
                  findTyreCon: findTyreCon,
                  findInteriorCon: findInteriorCon,
                  findExteriorCon: findExteriorCon,
                  veralrating: overalavg.toFixed(2),
                });
              }
            } else {
            }
          }
        } catch (error) {}
      } catch (error) {}
    };
    fetchData();
  }, [params.caseId]);

  return (
    <>
      {caseinfo && casePerfomanceinfo ? (
        <>
          <div>
            <div
              className="content"
              style={{
                border: "1px solid #686868",
                padding: "0 10px",
                width: "100%",
                position: "relative",
              }}
            >
              {/* A4 size */}
              <div className="row noprint p-3">
                <div className="col-sm-6">
                  <a
                    href=""
                    className="btn btn-success"
                    onclick="window.print();"
                  >
                    Print
                  </a>
                </div>
                <div className="col-sm-6 text-right">
                  <a href="" className="btn btn-success">
                    Cancel
                  </a>
                </div>
              </div>
              <div
                className="row"
                style={{
                  padding: "0 15px",
                  fontSize: "12pt",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="col-sm-6">
                  Ref. No / Loan No&nbsp;:&nbsp;{caseinfo.loanAgreementNo}
                </div>
                {caseinfo.caseId > 0 && caseinfo.caseId < 10 ? (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;0{caseinfo.caseId}
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;{caseinfo.caseId}
                    </div>
                  </>
                )}
              </div>
              <div
                style={{
                  padding: "2px 15px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    {caseinfo.requesterName === "TRUCKSUP SOLUTIONS PVT. LTD" ||
                    caseinfo.requesterName === "Trucksup Solution" ? (
                      <img
                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/TrucksHub.jpg"
                        style={{ height: "65px" }}
                      />
                    ) : (
                      <img src={organisationLogo} style={{ height: "60px" }} />
                    )}
                  </div>
                  <div className="col-sm-6 text-center">
                    {/* <br /> */}
                    <h4>
                      {caseinfo.requesterName ===
                        "TRUCKSUP SOLUTIONS PVT. LTD" ||
                      caseinfo.requesterName === "Trucksup Solution" ? (
                        <strong>
                          {/* <br /> */}
                          Inspection Report By Adsum
                          <p style={{ paddingLeft: "15px" }}>
                            {caseinfo.assetType}
                          </p>
                          {/* <br /> */}
                          <p>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                        </strong>
                      ) : (
                        <strong>
                          {/* <br /> */}
                          Valuation Report:
                          <p style={{ paddingLeft: "15px" }}>
                            {caseinfo.assetType}
                          </p>
                          {/* <br /> */}
                          <p>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                        </strong>
                      )}
                    </h4>
                    {/* <br /> */}
                    <p>&nbsp;&nbsp;</p>
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src={brandLogo} style={{ height: "60px" }} />
                  </div>
                </div>
              </div>
              <div style={{ padding: "3px 3px" }}>
                <div className="row">
                  <div className="col-sm-7">
                    {/* ==== main col 7*/}
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          City : {caseinfo.city}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 1,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          Color : {caseinfo.vehicleColor}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          Odometer in Kms : {caseinfo.meterReading}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          Fuel Type : {caseinfo.fueltype}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          Transmission :{" "}
                          {caseinfo.additionalFeatures.transmission}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>
                          {" "}
                          Accidental status : {caseinfo.otherDetails.accidental}
                        </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 5,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          <b style={{ color: "black" }}>
                            {" "}
                            Ex. Showroom Price&nbsp;:{caseinfo.marketPrice}
                          </b>
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 1,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          <b style={{ color: "black" }}>
                            {" "}
                            Estimated Market Value :{caseinfo.valuation}
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* ==== main col 7 end */}
                  <div className="col-sm-5 text-center imfix">
                    <img
                      src={caseinfo.images.frontImage}
                      className="fixed-img"
                    />
                    <br />
                  </div>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row" style={{ padding: "2px 1px" }}>
                <div
                  className="col-sm-12 newReport"
                  style={{ border: "1px solid #000", borderRadius: 2 }}
                >
                  <table width="100%" style={{ padding: "5px 5px" }}>
                    <tbody>
                      <tr style={{ height: "20px" }}>
                        {caseinfo?.assetType === "Commercial EV" ? (
                          <td width="12">
                            <div className="center-round">
                              <div className="legcontainer">
                                <img
                                  src={
                                    casePerfomanceinfo?.findEVMotorCon
                                      ?.roundImage
                                  }
                                  alt="Small Image"
                                  className="small-image"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                  className="image1"
                                  alt="Image 1"
                                />
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td width="12">
                            <div className="center-round">
                              <div className="legcontainer">
                                <img
                                  src={
                                    casePerfomanceinfo.findEngineCon.roundImage
                                  }
                                  alt="Small Image"
                                  className="small-image"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                  className="image1"
                                  alt="Image 1"
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findTransmissionCon
                                    .roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/transm.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findSuspensionCon
                                    .roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Suspension.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findBrakesCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Brakes.png"
                                className="image1"
                                alt="Image 1"
                                style={{ height: "28px", width: "30px" }}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findTyreCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/tyres.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        {caseinfo?.assetType === "Commercial EV" ? (
                          <td width="12">
                            <div className="center-round">
                              <div className="legcontainer">
                                <img
                                  src={
                                    casePerfomanceinfo.findBatteryCon.roundImage
                                  }
                                  alt="Small Image"
                                  className="small-image"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                  className="image1"
                                  alt="Image 1"
                                />
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td width="12">
                            <div className="center-round">
                              <div className="legcontainer">
                                <img
                                  src={
                                    casePerfomanceinfo.findInteriorCon
                                      .roundImage
                                  }
                                  alt="Small Image"
                                  className="small-image"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                  className="image1"
                                  alt="Image 1"
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findExteriorCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Exterior.png"
                                className="image1"
                                alt="Image 1"
                                style={{ height: "28px", width: "30px" }}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          {casePerfomanceinfo.veralrating > 0.01 &&
                          casePerfomanceinfo.veralrating < 2 ? (
                            <>
                              <div className="center-round">
                                <div className="legcontainer">
                                  <img
                                    //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                    src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png"
                                    alt="Small Image"
                                    className="small-image"
                                  />
                                  <h1
                                    className="image1"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {casePerfomanceinfo.veralrating}
                                  </h1>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {casePerfomanceinfo.veralrating > 2.01 &&
                              casePerfomanceinfo.veralrating < 4 ? (
                                <>
                                  <div className="center-round">
                                    <div className="legcontainer">
                                      <img
                                        //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png"
                                        alt="Small Image"
                                        className="small-image"
                                      />
                                      <h1
                                        className="image1"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {casePerfomanceinfo.veralrating}
                                      </h1>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {casePerfomanceinfo.veralrating > 4.01 &&
                                  casePerfomanceinfo.veralrating < 6 ? (
                                    <>
                                      <div className="center-round">
                                        <div className="legcontainer">
                                          <img
                                            //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                            src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                            alt="Small Image"
                                            className="small-image"
                                          />
                                          <div>
                                            <h1
                                              className="image1"
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              {casePerfomanceinfo.veralrating}
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {casePerfomanceinfo.veralrating > 6.01 &&
                                      casePerfomanceinfo.veralrating < 8 ? (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg07.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr className="legtext">
                        {caseinfo?.assetType === "Commercial EV" ? (
                          <td>
                            EV Motor
                            {/* <br /> */}
                            <p>
                              {" "}
                              {casePerfomanceinfo?.findEVMotorCon?.percentage}
                              /10
                            </p>
                          </td>
                        ) : (
                          <td>
                            Engine
                            {/* <br /> */}
                            <p>
                              {" "}
                              {casePerfomanceinfo.findEngineCon.percentage}/10
                            </p>
                          </td>
                        )}
                        <td>
                          Transmission
                          {/* <br /> */}
                          <p>
                            {casePerfomanceinfo.findTransmissionCon.percentage}
                            /10
                          </p>
                        </td>
                        <td>
                          Suspension
                          <p>
                            {casePerfomanceinfo.findSuspensionCon.percentage}/10
                          </p>
                        </td>
                        <td>
                          Brakes
                          <p>
                            {casePerfomanceinfo.findBrakesCon.percentage}/10
                          </p>
                        </td>
                        <td>
                          Tyres
                          <p>{casePerfomanceinfo.findTyreCon.percentage}/10</p>
                        </td>
                        {caseinfo?.assetType === "Commercial EV" ? (
                          <td>
                            EV Battery
                            {/* <br /> */}
                            <p>
                              {" "}
                              {casePerfomanceinfo?.findBatteryCon?.percentage}
                              /10
                            </p>
                          </td>
                        ) : (
                          <td>
                            Interior
                            {/* <br /> */}
                            <p>
                              {" "}
                              {casePerfomanceinfo.findInteriorCon.percentage}/10
                            </p>
                          </td>
                        )}
                        <td>
                          Exterior
                          <p>
                            {casePerfomanceinfo.findExteriorCon.percentage}/10
                          </p>
                        </td>
                        <td>
                          <strong>
                            OVERALL
                            <p>{casePerfomanceinfo.veralrating} of 10</p>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-sm-12 newReport">
                  <table
                    width="100%"
                    border={1}
                    style={{ fontSize: "10pt", border: "1px solid #688" }}
                  >
                    <tbody>
                      <tr className="p-1">
                        <td width="75%" rowSpan={2}>
                          &nbsp;&nbsp;&nbsp;&nbsp;Inspection Address
                          <p>
                            &nbsp;&nbsp;&nbsp;&nbsp;{caseinfo.vehicleLocation}
                          </p>
                        </td>
                        <td className="text-center">
                          <p>
                            Created Date:{" "}
                            <strong> {caseinfo.createdAt.slice(0, 10)}</strong>
                          </p>
                          <p>
                            Service Date:{" "}
                            <strong>
                              {" "}
                              {caseinfo.submittedAt.slice(0, 10)}
                            </strong>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div style={{ padding: 8 }} /> */}
              <table>
                <tbody>
                  <tr>
                    <td>
                      <div className="imgcontainer">
                        <img
                          src="/assets/Adsum Advisory Services Pvt. Ltd._files/car01.jpg"
                          className="image3"
                        />
                      </div>
                    </td>
                    <td>
                      <strong>&nbsp;&nbsp;VEHICLE DETAILS</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="row">
                <div className="col-sm-12 newReport">
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ verticalAlign: "top" }}>
                        <td width="24%">
                          <div
                            className="col-sm-12 newReport column-ht"
                            style={{ paddingTop: "0px", height: "100%" }}
                          >
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car08.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: "12px" }}>Registration</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.regdNo}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>Chasis Number</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.chasisNo}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>Engine Number</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.engNo}</strong>
                            </p>
                            <hr />
                          </div>
                        </td>
                        <td width="24%">
                          <div
                            className="col-sm-12 newReport column-ht"
                            style={{ paddingTop: "0px", height: "100%" }}
                          >
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car02.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: "12px" }}>Body Type</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.bodyType}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>Manufacture Year</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.manufacturingDate}</strong>
                            </p>
                            <p style={{ fontSize: "12px" }}>
                              Date of Registration
                            </p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.regdDate}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>Vehicle Type</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.assetType}</strong>
                            </p>
                          </div>
                        </td>
                        <td width="25%">
                          <div
                            className="col-sm-12 newReport column-ht"
                            style={{ paddingTop: "0px", height: "100%" }}
                          >
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car03.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: "12px" }}>Owner Name</p>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "#000",
                              }}
                            >
                              {caseinfo.regdOwner}
                            </p>
                            <hr />
                            <p style={{ fontSize: "13px" }}>Owner Serial No</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong> {caseinfo.ownerSerialNo}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>
                              Proposed Owner Name
                            </p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.name}</strong>
                            </p>
                            <hr />
                          </div>
                        </td>
                        <td width="25%">
                          <div
                            className="col-sm-12 newReport column-ht"
                            style={{ paddingTop: "0px", height: "100%" }}
                          >
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car04.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: "12px" }}>
                              Report Requested by
                            </p>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "#000",
                              }}
                            >
                              {caseinfo.requesterName}
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>Case Type</p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.caseType}</strong>
                            </p>
                            <hr />
                            <p style={{ fontSize: "12px" }}>
                              Purpose Of Valuation
                            </p>
                            <p style={{ fontSize: "13px" }}>
                              <strong>{caseinfo.valuationPurpose}</strong>
                            </p>
                            <hr />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <div style={{ padding: 2 }} />
                  <table border={1} width="100%">
                    <tbody>
                      <tr
                        className="text-center"
                        style={{ border: "1px solid black" }}
                      >
                        <td
                          width="50%"
                          style={{ borderRight: "1px solid #686868" }}
                        >
                          Insurance Company
                          <p>
                            <strong>{caseinfo.insuranceCompany}</strong>
                          </p>
                        </td>
                        <td width="25%">
                          Insurance Status
                          <div>
                            {caseinfo.insuranceStatus === "Yes" ? (
                              <strong>Expired</strong>
                            ) : (
                              <strong>Running</strong>
                            )}
                          </div>
                        </td>
                        <td style={{ borderLeft: "1px solid #686868" }}>
                          Insurance Valid Till
                          <p>
                            <strong>
                              {caseinfo.otherDetails.insuranceExpiry}
                            </strong>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ padding: 5 }} /> */}
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          <p>
                            {" "}
                            &nbsp;&nbsp;Remarks&nbsp;:&nbsp;
                            {caseinfo.yourRemark}
                          </p>
                          <p>
                            {" "}
                            &nbsp;&nbsp;Extrior Remarks&nbsp;:&nbsp;
                            {caseinfo.extriorRemark}
                          </p>
                          <a
                            className="ps-2"
                            target="_blank"
                            href={caseinfo.videos}
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            Preview Video Clip
                          </a>
                          &nbsp;
                          <a
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                            target="_blank"
                            href={caseinfo.imageUrl}
                          >
                            Preview Images
                          </a>
                        </td>
                        <td
                          width="35%"
                          rowSpan={2}
                          style={{ border: "1px solid black" }}
                        >
                          <div className="text-center">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src="/assets/stamp.jpeg"
                                width="40px"
                                height="40px"
                              />
                            </div>
                            <div>Authorized Signatory</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          &nbsp;&nbsp;Field Service By:&nbsp;
                          {caseinfo.fieldServiceBy}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* page footer ends */}
              {/* <div style={{ padding: 5 }} /> */}
              {/* <div style={{marginBottom:"10px"}}></div> */}
            </div>
            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              <div style={{ marginTop: 3 }}></div>
              {/*-  header */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    className="rcrowheight rtborder"
                    style={{ borderCollapse: "collapse" }}
                    width="100%"
                  >
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td>
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                        <td>
                          <strong>AS PER VAHAN</strong>
                        </td>
                        <td>
                          <strong>AS PER RC</strong>
                        </td>
                        <td>
                          <strong>AS PER ACTUAL</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Registration No</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.regdNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td
                          width="35%"
                          style={{ fontSize: "10px", fontWeight: "800" }}
                        >
                          Vehicle Mfg Name{" "}
                        </td>
                        <td>
                          {caseinfo.vehicleEdetails.vehicleManufacturerName}
                        </td>
                        <td>
                          {caseinfo.vehicleEdetails.vehicleManufacturerName}
                        </td>
                        <td>
                          {caseinfo.vehicleEdetails.vehicleManufacturerName}
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td
                          width="35%"
                          style={{ fontSize: "10px", fontWeight: "800" }}
                        >
                          Vehicle Model{" "}
                        </td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Chasis No&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.chasisNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Engine No&nbsp;:&nbsp;</td>
                        <td> {caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.engNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Color</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleColor}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fuel Type&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.fueltype}</td>
                      </tr>

                      <tr style={{ height: "10px" }}>
                        <td width="35%">Owner Serial No</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.ownerSerialNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Reg Owner Name</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.regdOwner}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Date Of Registration</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">RTA Name</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Year Of Manufacture</td>
                        <td>
                          {
                            caseinfo.vehicleEdetails
                              .vehicleManufacturingMonthYear
                          }
                        </td>
                        <td>
                          {
                            caseinfo.vehicleEdetails
                              .vehicleManufacturingMonthYear
                          }
                        </td>
                        <td>{caseinfo.manufacturingDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fitness Expiry Date</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.otherDetails.fitnessExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Insurance Exp Date</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.otherDetails.insuranceExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Tax Valid Up To</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Up To</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Type</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Hypothecation</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td> {caseinfo.hypothecationBank}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Cubic Capacity</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Gross Vehicle Weight</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Seating Capacity</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td>{caseinfo.seatingCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Number Plate</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{caseinfo.numberPlate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Status</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Blacklist Status</td>
                        <td>{caseinfo.vehicleEdetails.blacklistStatus}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Is Commercial</td>
                        {caseinfo.assetType === "Commercial" ? (
                          <td>Yes</td>
                        ) : (
                          <td>no</td>
                        )}
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Challan Details</td>
                        <td>NA</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td>
                          <strong>OTHERS:</strong>
                        </td>
                        <td>
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">
                          Document :{caseinfo.documentVerification}
                        </td>
                        <td width="35%">
                          Fitness Expiry Date :
                          {caseinfo.otherDetails.fitnessExpiry}
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Asset Type :{caseinfo.assetType}</td>
                        <td width="35%">
                          Insurance :{caseinfo.insuranceCompany}
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">
                          Manufacturing Year:{caseinfo.manufacturingDate}
                        </td>
                        <td width="35%">
                          Road Tax Validity Upto :
                          {caseinfo.otherDetails.roadTaxValidity}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "2px" }}>
                    <strong>OTHER DETAILS:</strong>
                  </h4>
                  <table className="rowheight" width="100%" border={1}>
                    <tbody>
                      <tr>
                        <td width="35%">Fuel Type</td>
                        <td width="30%">{caseinfo.fueltype}</td>
                        <td width="35%">Gross Vehicle Weight</td>
                        <td width="30%">{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr>
                        <td width="35%">Odormeter Type</td>
                        <td width="30%">
                          {caseinfo.additionalFeatures.odometer}
                        </td>
                        <td width="35%">Cubic Capacity</td>
                        <td width="30%">{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr>
                        <td width="35%">Vehicle Color</td>
                        <td width="30%">{caseinfo.vehicleColor}</td>
                        <td width="35%">Meter Reading In Km</td>
                        <td width="30%">{caseinfo.meterReading}</td>
                      </tr>
                      <tr>
                        <td width="35%">Number Plate</td>
                        <td width="30%">{caseinfo.numberPlate}</td>
                        <td width="35%">Seating Capacity</td>
                        <td width="30%">{caseinfo.seatingCapacity}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <!-- page 2 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              {/*-  header */}
              {caseinfo?.assetType === "Commercial EV" ? (
                <>
                  <h4 style={{ marginTop: "1px" }}>
                    <strong>EV MOTOR:</strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">Ev Motor</td>
                        <td width="30%">
                          {" "}
                          {caseinfo.commercial.evMotor?.motor}
                        </td>
                        <td width="30%">
                          {caseinfo?.commercial?.evMotor?.motor === "Yes" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                          ) : (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                          )}
                        </td>
                      </tr>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">EV Motor Working Status</td>
                        <td width="30%">
                          {caseinfo.otherDetails.evMotorCondition}
                        </td>
                        <td width="30%">
                          {caseinfo.otherDetails.evMotorCondition === "Poor" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.evMotorCondition ===
                          "Average" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.evMotorCondition ===
                          "Satisfactory" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.evMotorCondition === "Good" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.evMotorCondition ===
                          "Excellent" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">Power Converter</td>
                        <td width="30%">
                          {" "}
                          {caseinfo?.commercial?.evMotor?.powerConverter}
                        </td>
                        <td width="30%">
                          {caseinfo?.commercial?.evMotor?.powerConverter ===
                          "Yes" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                          ) : (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                          )}
                        </td>
                      </tr>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">Shaft Motor</td>
                        <td width="30%">
                          {caseinfo.commercial.evMotor.shaftMotor}
                        </td>
                        <td width="30%">
                          {caseinfo.commercial.evMotor.shaftMotor === "Poor" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.evMotor.shaftMotor ===
                          "Average" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.evMotor.shaftMotor ===
                          "Satisfactory" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.evMotor.shaftMotor === "Good" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.evMotor.shaftMotor ===
                          "Excellent" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : (
                <>
                  <h4 style={{ marginTop: "1px" }}>
                    <strong>ENGINE:</strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">Engine Condition</td>
                        <td width="30%">
                          {caseinfo.otherDetails.engineCondition}
                        </td>
                        <td width="30%">
                          {caseinfo.otherDetails.engineCondition === "Poor" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.engineCondition ===
                          "Average" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.engineCondition ===
                          "Satisfactory" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.engineCondition === "Good" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.otherDetails.engineCondition ===
                          "Excellent" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                      <tr style={{ height: "8px" }}>
                        <td width="35%">Engine Shield</td>
                        <td width="30%">
                          {caseinfo.commercial.engine.engineShield}
                        </td>
                        <td width="30%">
                          {caseinfo.commercial.engine.engineShield ===
                          "Poor" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.engine.engineShield ===
                          "Average" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.engine.engineShield ===
                          "Satisfactory" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.engine.engineShield ===
                          "Good" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                          ) : (
                            <></>
                          )}
                          {caseinfo.commercial.engine.engineShield ===
                          "Excellent" ? (
                            <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}
              <h2>
                <strong>TRANSMISSION:</strong>
              </h2>
              <table className="rowheight" width="100%">
                <tbody>
                  
                  <tr>
                    <td width="35%"> Transmission Condition</td>
                    <td width="30%">
                      {caseinfo.commercial.transmission.transmissionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.transmission
                        .transmissionCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.transmission
                        .transmissionCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.transmission
                        .transmissionCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.transmission
                        .transmissionCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.transmission
                        .transmissionCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2>
                <strong>SUSPENSION</strong>
              </h2>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Suspension Condition</td>
                    <td width="30%">
                      {caseinfo.commercial.suspension.suspensionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.suspension.suspensionCondition ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.suspension.suspensionCondition ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.suspension.suspensionCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.suspension.suspensionCondition ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.suspension.suspensionCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5>
                <strong>ELECTRICALS:</strong>
              </h5>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr>
                    <td width="35%">Battery Condition</td>
                    <td width="30%">
                      {caseinfo.commercial.electricals.batteryCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.electricals.batteryCondition ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.batteryCondition ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.batteryCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.batteryCondition ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.batteryCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Cluster Unit</td>
                    <td width="30%">
                      {caseinfo.commercial.electricals.clusterUnit}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.electricals.clusterUnit ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.clusterUnit ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.clusterUnit ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.clusterUnit ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.electricals.clusterUnit ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Headlamp</td>
                    <td width="30%">{caseinfo.otherDetails.headLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.headLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Taillamp</td>
                    <td width="30%">{caseinfo.otherDetails.tailLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.tailLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Front Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.frontIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Rear Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.rearIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              <h5>
                <strong>CABIN & INTERIOR:</strong>
              </h5>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Wind Screen</td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.windScreen}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.windScreen ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.windScreen ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.windScreen ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.windScreen ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.windScreen ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Side Glass</td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.sideGlasses}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.sideGlasses ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.sideGlasses ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.sideGlasses ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.sideGlasses ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.sideGlasses ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Doors</td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.doors}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.cabinNinterior.doors === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.doors ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.doors ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.doors === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.cabinNinterior.doors ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2>
                <strong>BRAKES</strong>
              </h2>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Front Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rear Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Hand Brake</td>
                    <td width="30%">{caseinfo.commercial.brakes.handBrake}</td>
                    <td width="30%">
                      {caseinfo.commercial.brakes.handBrake === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.brakes.handBrake === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.brakes.handBrake ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.brakes.handBrake === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.brakes.handBrake === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5>
                <strong>Body:</strong>
              </h5>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr>
                    <td width="35%">Body Condition</td>
                    <td width="30%">
                      {caseinfo.commercial.body.bodyCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.body.bodyCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.body.bodyCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.body.bodyCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.body.bodyCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.body.bodyCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5>
                <strong>Attachment:</strong>
              </h5>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr>
                    <td width="35%">Video</td>
                    <td width="30%">{caseinfo.videos ? "Yes" : "No"}</td>
                    <td width="30%">
                      {caseinfo.videos ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
             
              <h2>
                <strong>TYRES CONDITION</strong>
              </h2>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Axles Condition </td>
                    <td width="30%">
                      {caseinfo.commercial.tyresNConditions.axlesCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.commercial.tyresNConditions.axlesCondition ===
                      "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.tyresNConditions.axlesCondition ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.tyresNConditions.axlesCondition ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.tyresNConditions.axlesCondition ===
                      "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.commercial.tyresNConditions.axlesCondition ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5 style={{ marginTop: "1px" }}>
                <strong>ADDITIONAL DETAILS:</strong>
              </h5>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Whether Accidental</td>
                    <td width="30%">{caseinfo.otherDetails.accidental}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.accidental === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Level Of Maintenance</td>
                    <td width="30%">
                      {caseinfo.otherDetails.levelOfMaintenance}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.levelOfMaintenance === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                      "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                      "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                      "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
           
              {/* <div style={{ marginTop: 10 }}>&nbsp;</div> */}
            </div>
            {/* <!-- page 3 ends --> */}

            {/* <!-- page 4 ends --> */}
            <div className="page-break" />
            <div style={{ marginTop: 10 }}>&nbsp;</div>
            <div
              style={{
                padding: "2px 25px",
                border: "1px solid #000",
                width: "100%",
              }}
            >
              <div className="row">
                <div className="col-sm-3 p-2">
                  {caseinfo.requesterName === "TRUCKSUP SOLUTIONS PVT. LTD" ||
                  caseinfo.requesterName === "Trucksup Solution" ? (
                    <img
                      src="/assets/Adsum Advisory Services Pvt. Ltd._files/TrucksHub.jpg"
                      style={{ height: "65px" }}
                    />
                  ) : (
                    <img src={organisationLogo} style={{ height: "60px" }} />
                  )}
                </div>
                <div className="col-sm-6 text-center">
                  <br />
                  {caseinfo.requesterName === "TRUCKSUP SOLUTIONS PVT. LTD" ||
                  caseinfo.requesterName === "Trucksup Solution" ? (
                    <h4>
                      <strong>
                        Inspection Report By Adsum
                        <br />
                        {caseinfo.assetType}
                        <br />
                        {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                      </strong>
                    </h4>
                  ) : (
                    <h4>
                      <strong>
                        Valuation Report
                        <br />
                        {caseinfo.assetType}
                        <br />
                        {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                      </strong>
                    </h4>
                  )}
                  &nbsp;
                </div>
                <div className="col-sm-3 text-right">
                  <img src={brandLogo} />
                </div>
              </div>
            </div>
            {/*-  header */}

            {/*- content border */}
            <h4>
              <strong>IMAGES:</strong>
            </h4>
            <div className="row">
              <div className="col-sm-12 newReport">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {Object.keys(caseinfo.images).map((key) => {
                    if (
                      key === "selfieWithVehicle" &&
                      caseinfo.images[key] !== ""
                    ) {
                      return (
                        <span
                          key={key}
                          style={{ width: "45%", margin: "10px" }}
                        >
                          <a
                            target="_blank"
                            href={caseinfo.images.selfieWithVehicle}
                          >
                            <div style={{ position: "relative" }}>
                              <img
                                src={caseinfo.images.selfieWithVehicle}
                                style={{ height: "250px", width: "100%" }}
                                alt="Selfie with Vehicle"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                className="small-logo"
                                width="75px"
                                height="53px"
                                alt="Side Logo"
                              />
                            </div>
                          </a>
                        </span>
                      );
                    }
                    return null;
                  })}
                  {Object.keys(caseinfo.images).map((key) => {
                    if (key === "frontImage" && caseinfo.images[key] !== "") {
                      return (
                        <span
                          key={key}
                          style={{ width: "45%", margin: "10px" }}
                        >
                          <a
                            key={key}
                            target="_blank"
                            href={caseinfo.images.frontImage}
                          >
                            <div style={{ position: "relative" }}>
                              <img
                                src={caseinfo.images.frontImage}
                                style={{ height: "250px", width: "420px" }}
                                alt="Front Image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                className="small-logo"
                                width="75px"
                                height="53px"
                                alt="Side Logo"
                              />
                            </div>
                          </a>
                        </span>
                      );
                    }
                    return null;
                  })}
                  {Object.keys(caseinfo.images).map((key) => {
                    if (
                      key !== "selfieWithVehicle" &&
                      key !== "frontImage" &&
                      caseinfo.images[key] !== ""
                    ) {
                      return (
                        <span
                          key={key}
                          style={{ width: "45%", margin: "10px" }}
                        >
                          <a
                            key={key}
                            target="_blank"
                            href={caseinfo.images[key]}
                          >
                            <div style={{ position: "relative" }}>
                              <img
                                src={caseinfo.images[key]}
                                style={{ height: "200px", width: "420px" }}
                                alt="Other Images"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                className="small-logo"
                                width="75px"
                                height="53px"
                                alt="Side Logo"
                              />
                            </div>
                          </a>
                        </span>
                      );
                    }
                    return null;
                  })}
                </div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: "15px 10px",
                        border: "1px solid #686868",
                      }}
                    >
                      Disclaimer:
                      <br />
                      o This report is issued without prejudice
                      <br />
                      o The valuation has been done based on the superficial
                      examination of vehicle condition and the doeuments
                      provided at the time of inspection.
                      <br />
                      o This report is valid for the date of inspection and time
                      only
                      <br />
                      o This valuation has been performed to the best of our
                      ability and our responsibility is limited to proven
                      negligence.
                      <br />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          paddingRight: "20px",
                        }}
                      >
                        <img
                          src="/assets/stamp.jpeg"
                          width="80px"
                          height="80px"
                        />
                      </div>
                      <div className="text-right">
                        <p>Authorized Signatory</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 3 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Adsum Advisory Pvt Ltd.</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                        Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
              </div>
            </div>
            <br />
            {/* /div> <!-- A4 size */}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default CommercialInsuranceReport;
